/**
 * CRM Cache Service - Servizi per gestione cache centralizzata VTeniext
 * Endpoint: /api/crm/cache/*
 */

import { protectedApi } from './api';

/**
 * Inizializza TUTTA la cache CRM (Enti, Iniziative, Prenotazioni, Presenze, Conteggi)
 * Da chiamare all'avvio dell'applicazione per pre-caricare tutti i dati
 * Esegue sync in parallelo per massima performance
 *
 * @returns {Promise<Object>} Risultato inizializzazione con conteggi per ogni modulo
 */
export const initializeAllCache = async () => {
  try {
    console.log('[crmCacheService] Chiamata POST /api/crm/cache/init - Inizializzazione cache completa...');
    const response = await protectedApi.post('/api/crm/cache/init');

    console.log('[crmCacheService] Risposta init:', response.data);
    const { message, counts } = response.data;

    console.log('[crmCacheService] Cache CRM inizializzata:', counts);
    return {
      success: true,
      data: counts,
      message: message || 'Cache initialized successfully',
      code: 200
    };
  } catch (error) {
    console.error('[crmCacheService] Errore inizializzazione cache CRM:', error);
    const errorMessage =
      error.response?.data?.error ||
      error.response?.data?.detail ||
      error.message ||
      'Errore durante l\'inizializzazione della cache CRM';
    const code = error.response?.status || 500;

    return { success: false, message: errorMessage, code };
  }
};

/**
 * Invalida TUTTA la cache CRM
 * @returns {Promise<Object>} Risultato invalidazione
 */
export const invalidateAllCache = async () => {
  try {
    console.log('[crmCacheService] Chiamata POST /api/crm/cache/invalidate - Invalidazione cache completa...');
    const response = await protectedApi.post('/api/crm/cache/invalidate');

    console.log('[crmCacheService] Cache invalidata:', response.data);
    return {
      success: true,
      message: response.data.message || 'All caches invalidated',
      code: 200
    };
  } catch (error) {
    console.error('[crmCacheService] Errore invalidazione cache:', error);
    const errorMessage =
      error.response?.data?.error ||
      error.message ||
      'Errore durante l\'invalidazione della cache';
    const code = error.response?.status || 500;

    return { success: false, message: errorMessage, code };
  }
};

/**
 * Invalida cache di un modulo specifico
 * @param {string} module - Nome modulo: enti, iniziative, prenotazioni, presenze, conteggi
 * @returns {Promise<Object>} Risultato invalidazione
 */
export const invalidateModuleCache = async (module) => {
  try {
    console.log(`[crmCacheService] Chiamata POST /api/crm/cache/invalidate/${module} - Invalidazione cache modulo...`);
    const response = await protectedApi.post(`/api/crm/cache/invalidate/${module}`);

    console.log('[crmCacheService] Cache modulo invalidata:', response.data);
    return {
      success: true,
      message: response.data.message || `${module} cache invalidated`,
      code: 200
    };
  } catch (error) {
    console.error(`[crmCacheService] Errore invalidazione cache modulo ${module}:`, error);
    const errorMessage =
      error.response?.data?.error ||
      error.message ||
      `Errore durante l'invalidazione della cache ${module}`;
    const code = error.response?.status || 500;

    return { success: false, message: errorMessage, code };
  }
};
